import { createAction, props } from '@ngrx/store';
import { ToggleValue } from './interfaces';

export enum FeatureToggleType {
  OPS = 'ops',
  PERMISSION = 'permission',
  RELEASE = 'release',
}

export const updateFeatureToggles = createAction(
  '[Feature Toggles] Update feature toggles',
  props<{
    toggles: Record<string, ToggleValue>;
    toggleType: FeatureToggleType;
    namespace?: string;
  }>(),
);
